import { MapaCoreModule } from '@mapa/core';
import { UiSharedModule } from 'src/app/shared/ui/ui.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { AvisoRevisaoSeloComponent } from './aviso-revisao-selo/aviso-revisao-selo.component';
import { AvisoSuspensaoIntituicaoComponent } from './aviso-suspensao-intituicao/aviso-suspensao-intituicao.component';
import { AvisosContainerComponent } from './avisos-container/avisos-container.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AvisosContainerComponent, AvisoRevisaoSeloComponent, AvisoSuspensaoIntituicaoComponent],
  imports: [
    MapaCoreModule,
    CommonModule,
    CardModule,
    TableModule,
    UiSharedModule,
    RouterModule,
  ]
})
export class AvisosModule { }
